import { MY_WALLET } from "@stadium/constants/wallets";
import { HEADER_ANALYTICS_TARGET } from "@stadium/shared/src/constants/analytics/header";

export const USE_WALLET_OPTION_KEY = "useWallet";

export const USE_WALLET_OPTION = {
  key: USE_WALLET_OPTION_KEY,
  label: MY_WALLET,
};

/** `target` for `useWithAnalytics` in this module (see `HEADER_EVENT_LOCATION` + `HEADER_ANALYTICS_TARGET`). */
export const USER_FUNDS_ANALYTICS_TARGET = {
  WALLET: HEADER_ANALYTICS_TARGET.WALLET,
  REDEEM: HEADER_ANALYTICS_TARGET.REDEEM,
  SEND_CTA: HEADER_ANALYTICS_TARGET.SEND_CTA,
};
